function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M26.454 0H1.546C.692 0 0 .692 0 1.546v24.91C0 27.307.692 28 1.546 28h13.41V17.157h-3.649v-4.226h3.65V9.815c0-3.616 2.208-5.586 5.435-5.586 1.546 0 2.874.116 3.261.167v3.78l-2.238.001c-1.754 0-2.094.834-2.094 2.057v2.698h4.185l-.545 4.226h-3.64V28h7.135c.852 0 1.544-.692 1.544-1.546V1.546C28 .692 27.308 0 26.454 0z",
  fill: "url(#facebook_svg__paint0_linear)"
});

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "facebook_svg__paint0_linear",
  x1: 0,
  y1: 0,
  x2: 28,
  y2: 28,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#77BDFF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#0E4EFF"
})));

var SvgFacebook = function SvgFacebook(props) {
  return React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgc3R5bGU9Im1peC1ibGVuZC1tb2RlOmhhcmQtbGlnaHQiPgo8cGF0aCBkPSJNMjYuNDU0MiAwSDEuNTQ1ODNDMC42OTE4MzMgMCAwIDAuNjkxODMzIDAgMS41NDU4M1YyNi40NTUzQzAgMjcuMzA4MiAwLjY5MTgzMyAyOCAxLjU0NTgzIDI4SDE0Ljk1NjdWMTcuMTU3SDExLjMwNzNWMTIuOTMxM0gxNC45NTY3VjkuODE1MTdDMTQuOTU2NyA2LjE5ODUgMTcuMTY1MiA0LjIyOTE3IDIwLjM5MjIgNC4yMjkxN0MyMS45MzggNC4yMjkxNyAyMy4yNjU3IDQuMzQ0NjcgMjMuNjUzIDQuMzk2VjguMTc2TDIxLjQxNTMgOC4xNzcxN0MxOS42NjA3IDguMTc3MTcgMTkuMzIxMiA5LjAxMTMzIDE5LjMyMTIgMTAuMjM0VjEyLjkzMjVIMjMuNTA2TDIyLjk2MTIgMTcuMTU4MkgxOS4zMjEyVjI4SDI2LjQ1NjVDMjcuMzA4MiAyOCAyOCAyNy4zMDgyIDI4IDI2LjQ1NDJWMS41NDU4M0MyOCAwLjY5MTgzMyAyNy4zMDgyIDAgMjYuNDU0MiAwVjBaIiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXIpIi8+CjwvZz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhciIgeDE9IjAiIHkxPSIwIiB4Mj0iMjcuOTk5OSIgeTI9IjI4IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiM3N0JERkYiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMEU0RUZGIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==";
export { SvgFacebook as ReactComponent };